import React, { useEffect, useState } from 'react'
import './index.css'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from './pages/static/login/login'
import BrandManagementPage from './pages/settings/small-group-management-pages/brand-management-page/brand-management-page'
import { ProtectedRoute } from './services/routes/protected-route'
import SalesOrderManagementPage from './pages/order/sales-order/sales-order-management-page'
import DepartmentManagementPage from './pages/settings/small-group-management-pages/department-management-page/department-management-page'
import RoleManagementPage from './pages/settings/small-group-management-pages/role-management-page/role-management-page'
import CustomerSourceManagementPage from './pages/settings/small-group-management-pages/customer-source-management-page/customer-source-management-page'
import PaymentCycleManagementPage from './pages/settings/small-group-management-pages/payment-cycle-management-page/payment-cycle-management-page'
import CustomerGroupManagementPage from './pages/settings/customer-group-management-page/customer-group-management-page'
import CustomerGroup1ManagementPage from './pages/settings/small-group-management-pages/customer-group1-management-page/customer-group1-management-page'
import CustomerGroup2ManagementPage from './pages/settings/small-group-management-pages/customer-group2-management-page/customer-group2-management-page'
import CustomerGroup3ManagementPage from './pages/settings/small-group-management-pages/customer-group3-management-page/customer-group3-management-page'
import CustomerGroup4ManagementPage from './pages/settings/small-group-management-pages/customer-group4-management-page/customer-group4-management-page'
import CustomerGroup5ManagementPage from './pages/settings/small-group-management-pages/customer-group5-management-page/customer-group5-management-page'
import Home from './pages/static/dashboard/sales-order-dashboard/sales-order-dashboard'
import unExitPage from './services/lib/404'
import CreateTicketPageUser from './pages/settings/create-ticket-page/create-ticket-user'
import CreateTicketPageAdmin from './pages/settings/create-ticket-page/create-ticket-admin'
import TicketFinalProcessPage from './pages/settings/create-ticket-page/ticket-final-process'
import EmployeeManagementPage from './pages/settings/employee-management-page/employee-management-page'
import Assessment from './pages/settings/assessment/assessment/page'
import AssessmentItem from './pages/settings/assessment/assessment-item/page'
import AssessmentPlan from './pages/settings/assessment/assessment-plan/page'
import BaseProduct from './pages/product/base-product-management-page/base-product-management-page'
import Product from './pages/product/product-management-page/product-management-page'
import ProductManagementDialog from './pages/product/product-management-dialog/product-management-dialog'
import OutsourceProductManagementPage from './pages/product/outsource-product-management-page/outsource-product-management-page'
import DeletedBaseProductPage from './pages/product/deleted-base-product-page/deleted-base-product-page'
import DeletedProductPage from './pages/product/deleted-product-page/deleted-product-page'
import DeletedRawMaterialPage from './pages/product/deleted-raw-material-page/deleted-raw-material-page'
import WorkArrangement from './pages/order/work-order/manager/work-arrangement'
import CustomerManagementPage from './pages/customer/customer-management-page/customer-management-page'
import CityManagementPage from './pages/settings/small-group-management-pages/city-management-page/city-management-page'
import HolidayManagementPage from './pages/settings/small-group-management-pages/holiday-management-page/holiday-management-page'
import ProductTypeManagementPage from './pages/settings/small-group-management-pages/product-type-management-page/product-type-management-page'
import RawMaterialManagementPage from './pages/settings/small-group-management-pages/raw-material-management-page/raw-material-management-page'
import PackagingTypeManagementPage from './pages/settings/small-group-management-pages/packaging-type-management-page/packaging-type-management-page'
import PlateTypeManagementPage from './pages/settings/small-group-management-pages/plate-type-management-page/plate-type-management-page'
import PageGroupManagementPage from './pages/settings/page-group-management-page/page-group-management-page'
import DeliveryMethodManagementPage from './pages/settings/small-group-management-pages/delivery-method-management-page/delivery-method-management-page'
import QuotationManagementPage from './pages/customer/quotation-management-page/quotation-management-page'
import SuborderList from './pages/order/work-order/operator/suborder-list/suborder-list'
import WorkOrderManagementPage from './pages/order/work-order/manager/work-order-management-page/work-order-management-page'
import RawMaterialApplicationManagementPage
  from './pages/order/work-order/raw-material/raw-material-application-management-page/raw-material-application-management-page'
import WarehouseManagement from './pages/warehouse/warehouse-Management'
import TemporaryZone from './pages/warehouse/temporary-Zone'
import RelocateBoxes from './pages/warehouse/relocate-Boxes'
import PackagingList from './pages/order/work-order/operator/packaging-list/packaging-list'
import StockMonitorPage from './pages/order/work-order/manager/stock-monitor/stock-monitor-page'
import SalesOrder from './pages/order/order-product-tracking/sales-order'
import SameBatch from './pages/order/order-product-tracking/same-batch'
import SubOrder from './pages/order/order-product-tracking/sub-orders'
import ProductionDashBoard from './pages/static/dashboard/production-dashboard/production-dashboard'
import WarehouseConfirmManagementPage
  from './pages/order/work-order/raw-material/raw-material-application-management-page/warehouse-confirm-management-page'
import AwaitingDispatchList from './pages/warehouse/dispatch/dispatch-list/awaiting-dispatch-list'
import PickupList from './pages/warehouse/dispatch/dispatch-list/pickup-list'
import DispatchedTable from './pages/warehouse/dispatch/dispatch-list/dispatched-table/dispatched-table'
import DeliveryDetailsReportPage from './pages/warehouse/dispatch/delivery-details-report/delivery-details-report-page'
import StockLogPage from './pages/stock-log/stock-log-page'
import OperationLogPage from './pages/reports/operation-log/operation-log-page'
import CourierManagementPage from './pages/settings/small-group-management-pages/courier-management-page/courier-management-page'
import { PurchaseOrderPage } from './pages/order/purchase-order/purchase-order-page/purchase-order-page'
import { PurchaseOrderReceivingPage } from './pages/order/purchase-order/purchase-order-page/purchase-order-receiving-page'
import { SupplierManagementPage } from './pages/order/purchase-order/supplier-management-page/supplier-management-page'
import RawMaterialStockMonitorPage
  from './pages/order/purchase-order/raw-material-stock-monitor/raw-material-stock-monitor-page'
import ProductOptionManagementPage
  from './pages/settings/small-group-management-pages/product-option-management-page/product-option-management-page'
import RawMaterialBoxManagementPage
  from './pages/warehouse/box-management/raw-material-box-management-page/raw-material-box-management-page'
import BoxManagementPage from './pages/warehouse/box-management/box-management-page/box-management-page'
import BoxInfoPage from './pages/warehouse/box-management/box-info-page/box-info-page'
import ApproveDeletePage from './pages/warehouse/box-management/approve_delete/approve-delete-page'
import ReturnManagementPage from './pages/warehouse/return_management/return-management-page/return-management-page'
import ProdInventoryReport from './pages/reports/Prod-inventory-report/index'
import ProductionOverrunReportPage from './pages/reports/production-overrun-report/production-overrun-report-page'
import InventoryComparisonReportPage from './pages/reports/inventory-comparison-report/inventory-comparison-report-page'
import SlowMovingStockReportPage from './pages/reports/slow-moving-stock-report/slow-moving-stock-report-page'
import RawMaterialApplicationDetailsManagementPage
  from './pages/order/work-order/raw-material/raw-material-application-details-management-page/raw-material-application-details-management-page'
import TicketList from './pages/order/ticket/ticket-list'
import UnloadingInspectionManagementPage from './pages/warehouse/unloading/unloading-inspection-page'
import PalletStackingManagementPage
  from './pages/settings/small-group-management-pages/pallet-stacking-management-page/pallet-stacking-management-page'
import InvoiceManagementPage from './pages/order/invoice/inovice-management-page'
import SalesReportPage from './pages/order/invoice/sales-report-management-page'
import NewSalesReportPage from './pages/order/invoice/new-sales-report-management-page'
import HrListPage from './pages/settings/hr/hr-list-page/hr-list-page'
import { PurchaseOrderPageApprove } from './pages/order/purchase-order/purchase-order-page/purchase-order-page-approve'
import { PayablePage } from './pages/order/purchase-order/purchase-order-page/payable-page'
import RolePageMappingManagementPage from './pages/settings/role-page-mapping-management-page/role-page-mapping-management-page'
import OnlineSalesOrderManagementPage from './pages/order/online-sales-order/online-sales-order-management-page'
import MachineManagementPage from './pages/settings/machine-management-page/machine-management-page'
import RecordTypeManagementPage
  from './pages/settings/small-group-management-pages/record-type-management-page/record-type-management-page'
import ContractTypeManagementPage
  from './pages/settings/small-group-management-pages/contract-type-management-page/contract-type-management-page'
import RelocatePlatePage from './pages/warehouse/relocate-plate/relocate-plate-page'
import QuoteItemsManagementPage
  from './pages/settings/small-group-management-pages/quote-items-management-page/quote-items-management-page'
import BaseProductInfosPage from './pages/product/base-product-infos-page/base-product-infos-page'
import SalesProductInfosPage from './pages/product/sales-product-infos-page/sales-product-infos-page'
import QuotationCustomerSidePage
  from './pages/customer/quotation-management-page/quotation-customer-side-page/quotation-customer-side-page'
import NotificationManagementPage from './pages/settings/notification-management-page/notification-management-page'
import QuotationOnlyDraft from './pages/customer/quotation-management-page/quotation-only-draft'
import QuotationBaseDraft from './pages/customer/quotation-management-page/quotation-base-draft'
import contractPrice from './pages/customer/quotation-management-page/contract-price'
import CustomerOnlySales from './pages/customer/customer-management-page/customer-only-sales'
import CustomerSalesView from './pages/customer/customer-management-page/customer-sales-view'
import DailyReport from './pages/static/daily-report'
import WorkArrangementPresentationOnlyPage
  from './pages/order/work-order/manager/work-arrangement/work-arrangement-presentation-only-page'
import DailyReportRecord from './pages/product/daily-report-record'
import SalesProductsList from './pages/product/base-product-infos-page/sales-products-list'
import SaleOrderManagementForSales from './pages/order/sales-order/sales-order-management-for-sales'
import DraftOrderManagementForSales from './pages/order/draft-sales-order/draft-sales-order-management-page'
import SaleOrderManagementForCustomer from './pages/order/sales-order/sales-order-management-for-customer'
import OnlineUserManagementPage from './pages/settings/online-user-management-page/online-user-management-page'
import InspectionReport from './pages/reports/inspection-report'
import PalletList from './pages/warehouse/pallet-list/index'
import PalletLog from './pages/warehouse/pallet-log/index'
import CustomerPalletList from './pages/warehouse/pallet-log/customerPalletList/customerPalletList'
import OfflineAlertModal from './components/common/others/offline-alert-modal'
import QuotationWarnings from './pages/customer/quotation-management-page/quotation-warnings'
import QuotationItemDeletedPage from './pages/customer/quotation-management-page/quotation-item-deleted-page/quotation-item-deleted-page'
import { getCookie, setCookie} from 'react-use-cookie'
import { toggleBlur } from './services/lib/utils/helpers'
import MonitorProductPage from './pages/product/monitor-product-page/monitor-product-page'
import MonitorPOProductPage from './pages/product/monitor-product-page/monitor-po-product-page'
import ProductBarcodeManagementPage from './pages/settings/small-group-management-pages/product-barcode-management-page/product-barcode-management-page'
import MonitorProductGroupManagementPage from './pages/settings/monitor-product-group/MonitorProductGroupManagementPage'
import WorkOrderTrackingPage from  './pages/order/work-order/manager/work-order-tracking/work-order-tracking'
import HoldProductListPage from  './pages/warehouse/box-management/hold-product-list/hold-product-list'
import { Component } from 'ag-grid-community'
import WeeklyReportPage from './pages/settings/weekly-report-page/weekly-report-page';
import LeaveRequestPage from './pages/settings/leave-request-page/leave-request-page';
import LeaveRequestApprovePage from './pages/settings/leave-request-page/leave-request-approve-page';
import ProductionReportDashboard from './pages/reports/production-dashboard/production-report-dashboard'
import WeeklyAttendancePage from './pages/settings/weekly-attendance-page/weekly-attendance-page';
import AttendanceRecordsPage from './pages/settings/attendance-records/attendance-records-page';
import ProductionMaintenanceLogPage from './pages/product/maintenance-log-page/maintenance-log-page';
import ProductClassificationManagementPage from './pages/settings/small-group-management-pages/product-classification-management-page/product-classification-management-page';
import ExceptionalLogPage from './pages/exceptional-log/exceptional-log-page';
import { usePagesConfigListener } from './services/title/usePagesConfigListener';

// ===== Task pages =====
import NewTaskPage from './pages/tasks/new-task-page/NewTaskPage';
import TaskListPage from './pages/tasks/task-list-page/TaskListPage';
import TaskDetailPage from './pages/tasks/task-detail-page/TaskDetailPage';
import TaskManagementPage from './pages/tasks/task-management-page/TaskManagementPage';
import MyTaskPage from './pages/tasks/my-task-page/MyTaskPage';
import TaskNotificationPage from './pages/tasks/task-notification-page/TaskNotificationPage';
import TaskProgressPage from './pages/tasks/task-progress-page/TaskProgressPage';

// === 引入公共 Header（只给 /tasks/* 用，避免旧页重复） ===
import CommonHeader from './components/layout/common-header';



//getCookie('id')
  const App = () => {
      usePagesConfigListener();
  const getOffline= () => {
    console.log(localStorage.getItem('USER_TYPE'))
    if (localStorage.getItem('USER_TYPE') !== '"1"') return false
    console.log(window.location.pathname )
    if (window.location.pathname === '/') return false
    const offline = JSON.parse(localStorage.getItem('CHECK_USER_OFFLINE')!) ? JSON.parse(localStorage.getItem('CHECK_USER_OFFLINE')!) : false
    console.log("getOffline",localStorage.getItem('CHECK_USER_OFFLINE'))
    if (offline==true){
      if (getCookie('userName') == null || getCookie('userName') == "") 
      {
        // cookie.removeItem('token')
        localStorage.removeItem('CHECK_USER_OFFLINE')
        setCookie('lockedFlag',"")
        sessionStorage.setItem('TimeoutFlag',"")
        window.location.href = '/';
      }
    }
    if (offline==true){
        setTimeout(() => {
          toggleBlur(true)
        }, 2000);
    }
    
    return offline
  }
  const [modalVisible, setModalVisible] = useState<boolean>(getOffline())

  useEffect(() => {
    checkTimeout()
  }, [])

  useEffect(() => {
    window.addEventListener('onbeforeunload', function () {
      alert('Page Refreshed')
    })
    if (window.performance) {
      if (performance.navigation.type === 1) {
        console.log('This page is reloaded')
      } else {
        console.log('This page is not reloaded')
      }
    }
  })
  const checkTimeout = () => {
    let count = 0
    const outTime = 60 * 60
    // const outTime = 10
    window.setInterval(function() {
      // console.log('location', window.location.pathname)
      if (localStorage.getItem('USER_TYPE') !== '"1"') return
      if (getCookie('userName') == null ||getCookie('userName') == "") return
      if (window.location.pathname === '/') return
      if (sessionStorage.getItem('TimeoutFlag') === '1' || sessionStorage.getItem('TimeoutFlag') === null) {
        sessionStorage.setItem('TimeoutFlag', '0')
        count = 0
        return
      }
      count++
      // console.log(count)
      if (count === outTime) {
        setCookie('lockedFlag', '1')
        localStorage.setItem('CHECK_USER_OFFLINE', JSON.stringify(true))
        setModalVisible(true)
        toggleBlur(true)
      }
    }, 1000)

    document.onmousemove = (event: any) => {
      // console.log('move', count)
      sessionStorage.setItem('TimeoutFlag', '1')
      count = 0
    }
  }
  const closeModal = () => {
    toggleBlur(false)
    setModalVisible(false)
  }

  // —— 仅给 /tasks/* 的页面包一层 Header —— //
  const RouteWithHeader = ({ component: Page, ...rest }: any) => (
    <Route
      {...rest}
      render={(props: any) => (
        <>
          <CommonHeader />
          <div style={{ paddingTop: 8 }}>
            <Page {...props} />
          </div>
        </>
      )}
    />
  );

  return (
    <Router>
      <Switch>
        <Route exact path={'/cus-qot'} component={QuotationCustomerSidePage} />
        
        {/* ===== Tasks：统一带 Header，且不走 ProtectedRoute，避免被权限拦回 /home ===== */}
        <RouteWithHeader exact path="/tasks/new" component={NewTaskPage} />
        <RouteWithHeader exact path="/tasks/my" component={MyTaskPage} />
        <RouteWithHeader
          exact
          path="/tasks/notification/new"
          component={TaskNotificationPage}
        />
        <RouteWithHeader
          exact
          path="/tasks/:taskId/notification/new"
          component={TaskNotificationPage}
        />
        <RouteWithHeader
          exact
          path="/tasks/:taskId/progress"
          component={TaskProgressPage}
        />
        <RouteWithHeader
          exact
          path="/tasks/detail/:id"
          component={TaskDetailPage}
        />
        <RouteWithHeader
          exact
          path="/tasks/detail"
          component={TaskDetailPage}
        />
        <RouteWithHeader
          exact
          path="/tasks/:id/edit"
          component={TaskManagementPage}
        />
        <RouteWithHeader exact path="/tasks" component={TaskListPage} />
        {/* ======================================================= */}
        
        {
          routes.map((route: any, index: number) => {
            return (
              <ProtectedRoute exact key={index} path={route.path} component={route.component} />
            )
          })
        }
        <ProtectedRoute exact path='*' component={unExitPage} />
      </Switch>
      <OfflineAlertModal modalVisible={modalVisible} closeModal={closeModal}/>
    </Router>
  )
}

const routes: any = [
  {
    path: '/',
    component: Login
  },
  {
    path: '/home',
    component: Home
  },
  {
    path:'/WorkOrderTracking',
    component: WorkOrderTrackingPage
  },
  {
    path: '/weekly-report/:role',
    component: WeeklyReportPage
  },
  {
    path:'/HoldProductList',
    component: HoldProductListPage
  },  
  {
    path: '/pallet-list',
    component: PalletList
  },
  {
    path: '/brand-management-page',
    component: BrandManagementPage
  },
  {
    path: '/quotation-management',
    component: QuotationManagementPage
  },
  {
    path: '/work-order',
    component: WorkOrderManagementPage
  },
  {
    path: '/production-report-dashboard',
    component: ProductionReportDashboard
  },
  {
    path: '/stock-monitor',
    component: StockMonitorPage
  },
  {
    path: '/base-product',
    component: BaseProduct
  },
  {
    path: '/product',
    component: Product
  },
  {
    path: '/deleted-base-product',
    component: DeletedBaseProductPage
  },
  {
    path: '/deleted-product',
    component: DeletedProductPage
  },//QuotationItemDeletedPage
  {
    path: '/quotation-item-deleted',
    component: QuotationItemDeletedPage
  },//  
  {
    path: '/deleted-raw-material',
    component: DeletedRawMaterialPage
  },    
  {
    path: '/outsource-product',
    component: OutsourceProductManagementPage
  },  
  {
    path: '/page-management',
    component: PageGroupManagementPage
  },
  {
    path: '/sales-order-management',
    component: SalesOrderManagementPage
  },
  {
    path: '/sales-order-management-for-sales',
    component: SaleOrderManagementForSales
  },
  {
    path: '/draft-order-management-for-sales',
    component: DraftOrderManagementForSales
  },  
  {
    path: '/sales-order-management-for-customer',
    component: SaleOrderManagementForCustomer
  },
  {
    path: '/department-management',
    component: DepartmentManagementPage
  },
  {
    path: '/role-management',
    component: RoleManagementPage
  },
  {
    path: '/customer-source-management',
    component: CustomerSourceManagementPage
  },
  {
    path: '/customer-group-management',
    component: CustomerGroupManagementPage
  },
  {
    path: '/customer-group1-management',
    component: CustomerGroup1ManagementPage
  },
  {
    path: '/customer-group2-management',
    component: CustomerGroup2ManagementPage
  },
  {
    path: '/customer-group3-management',
    component: CustomerGroup3ManagementPage
  },
  {
    path: '/customer-group4-management',
    component: CustomerGroup4ManagementPage
  },
  {
    path: '/customer-group5-management',
    component: CustomerGroup5ManagementPage
  },
  {
    path: '/payment-cycle-management',
    component: PaymentCycleManagementPage
  }, {
    path: '/create-ticket',
    component: CreateTicketPageUser
  },
  {
    path: '/create-ticket-admin',
    component: CreateTicketPageAdmin
  },
  {
    path: '/ticket-final-process',
    component: TicketFinalProcessPage
  },
  {
    path: '/employee-management',
    component: EmployeeManagementPage
  },
  {
    path: '/work-arrangement',
    component: WorkArrangement
  },
  {
    path: '/customer-management-page',
    component: CustomerManagementPage
  },
  {
    path: '/city-management',
    component: CityManagementPage
  },
  {
    path: '/holiday-management',
    component: HolidayManagementPage
  },
  {
    path: '/raw-material-management',
    component: RawMaterialManagementPage
  },
  {
    path: '/raw-material-application-management',
    component: RawMaterialApplicationManagementPage
  },
  {
    path: '/warehouse-confirm',
    component: WarehouseConfirmManagementPage
  },
  {
    path: '/packaging-type-management',
    component: PackagingTypeManagementPage
  },
  {
    path: '/pallet-stacking-management',
    component: PalletStackingManagementPage
  },
  {
    path: '/plate-type-management',
    component: PlateTypeManagementPage
  },
  {
    path: '/delivery-method-management',
    component: DeliveryMethodManagementPage
  },
  {
    path: '/product-type-management',
    component: ProductTypeManagementPage
  },
  {
    path: '/suborder',
    component: SuborderList
  },
  {
    path: '/packaging',
    component: PackagingList
  },
  {
    path: '/warehouse-management',
    component: WarehouseManagement
  },
  {
    path: '/temporary-zone',
    component: TemporaryZone
  },
  {
    path: '/monitor-product-group-management',
    component: MonitorProductGroupManagementPage
  },
  {
    path: '/relocate-boxes',
    component: RelocateBoxes
  },
  {
    path: '/unloading-inspection',
    component: UnloadingInspectionManagementPage
  },
  {
    path: '/production-Tracking/sales-order',
    component: SalesOrder
  },
  {
    path: '/production-Tracking/same-batch',
    component: SameBatch
  },
  {
    path: '/production-Tracking/sub-orders',
    component: SubOrder
  },
  {
    path: '/production-dashboard',
    component: ProductionDashBoard
  },
  {
    path: '/awaiting-dispatch',
    component: AwaitingDispatchList
  },
  {
    path: '/PickupList',
    component: PickupList
  },  
  {
    path: '/delivered',
    component: DispatchedTable
  },
  {
    path: '/dispatch',
    component: DispatchedTable
  },
  {
    path: '/OnBoard',
    component: DispatchedTable
  },
  {
    path: '/delivery-details-report',
    component: DeliveryDetailsReportPage
  },
  {
    path: '/stock-log',
    component: StockLogPage
  },
  {
    path: '/operation-log',
    component: OperationLogPage
  },
  {
    path: '/courier-management',
    component: CourierManagementPage
  },
  {
    path: '/purchase-order',
    component: PurchaseOrderPage
  },
  {
    path: '/purchase-order-receiving',
    component: PurchaseOrderReceivingPage
  },
  {
    path: '/online-user',
    component: OnlineUserManagementPage
  },
  {
    path: '/purchase-order-approve',
    component: PurchaseOrderPageApprove
  },
  {
    path: '/supplier-management',
    component: SupplierManagementPage
  },
  {
    path: '/raw-material-stock-monitor',
    component: RawMaterialStockMonitorPage
  },
  {
    path: '/product-option-management',
    component: ProductOptionManagementPage
  },
  {
    path: '/raw-material-box-management',
    component: RawMaterialBoxManagementPage
  },
  {
    path: '/box-management',
    component: BoxManagementPage
  },
  {
    path: '/box-info',
    component: BoxInfoPage
  },  
  {
    path: '/return-management',
    component: ReturnManagementPage
  },
  {
    path: '/application-details',
    component: RawMaterialApplicationDetailsManagementPage
  },
  {
    path: '/ticket',
    component: TicketList
  },
  {
    path: '/invoice',
    component: InvoiceManagementPage
  },
  {   
  path: '/invoice22',
  component: InvoiceManagementPage
},
{
  path: '/invoice23&41',
  component: InvoiceManagementPage
},
{
  path: '/salesReport/:id',
  component: SalesReportPage
},
{
  path: '/newSalesReport/:id',
  component: NewSalesReportPage
},
{
    path: '/hr-list-management',
    component: HrListPage
  },
  {
    path: '/role-page-mapping-management',
    component: RolePageMappingManagementPage
  },
  {
    path: '/online-sales-order',
    component: OnlineSalesOrderManagementPage
  },
  {
    path: '/machine-management',
    component: MachineManagementPage
  },
  {
    path: '/record-type-management',
    component: RecordTypeManagementPage
  },
  {
    path: '/contract-type-management',
    component: ContractTypeManagementPage
  },
  {
    path: '/relocate-pallet',
    component: RelocatePlatePage
  },
  {
    path: '/quote-items-management',
    component: QuoteItemsManagementPage
  },
  {
    path: '/base-product-infos',
    component: BaseProductInfosPage
  },
  {
    path: '/sales-products-list',
    component: SalesProductsList
  },
  {
    path: '/sales-product-infos',
    component: SalesProductInfosPage
  },
  {
    path: '/notification-management',
    component: NotificationManagementPage
  },
  {
    path: '/assessment-items',
    component: AssessmentItem
  },
  // {
  //   path: '/assessment-config',
  //   component: AssessmentConfig
  // },
  {
    path: '/payable',
    component: PayablePage
  },  
  {
    path: '/assessment-plan',
    component: AssessmentPlan
  },
  {
    path: '/assessment',
    component: Assessment
  },
  {
    path: '/quote-only-draft',
    component: QuotationOnlyDraft
  },
  {
    path: '/quote-base-draft',
    component: QuotationBaseDraft
  },
  {
    path: '/contractPrice',
    component: contractPrice
  },  
  {
    path: '/customer-only-sales',
    component: CustomerOnlySales
  },
  {
    path: '/customer-infos',
    component: CustomerSalesView
  },
  {
    path: '/daily-report',
    component: DailyReport
  },
  {
    path: '/work-arrangement-present',
    component: WorkArrangementPresentationOnlyPage
  },
  {
    path: '/daily-report-record',
    component: DailyReportRecord
  },
  {
    path: '/inspection-report',
    component: InspectionReport
  },
  {
    path: '/prod-inventory-report',
    component: ProdInventoryReport
  }  
  ,
  {
    path: '/pallet-stocklog',
    component: PalletLog
  }    
  ,
  {
    path: '/customer-pallet',
    component: CustomerPalletList
  }  //
  ,
  {
    path: '/approve-delete',
    component: ApproveDeletePage
  } 
  ,  
  {
    path: '/quotation—warnings',
    component: QuotationWarnings
  } 
  ,
  {
    path: '/monitor-product',
    component: MonitorProductPage
  } 
  ,
  {
    path: '/monitor-purchase-product',
    component: MonitorPOProductPage
  } ,
  {
    path: '/product-barcode-management',
    component: ProductBarcodeManagementPage
  }     
  ,
  {
    path: '/leave-request',
    component: LeaveRequestPage
  },
  {
    path: '/leave-request-approval',
    component: LeaveRequestApprovePage
  },
  {
    path:'/weekly-attendance',
    component: WeeklyAttendancePage
  },
  {
    path:'/attendance-records',
    component: AttendanceRecordsPage
  },
  {
    path: '/production-maintenance-log',
    component: ProductionMaintenanceLogPage
  },
  {
    path: '/product-classification-management',
    component: ProductClassificationManagementPage
  },
  {    
    path: '/exceptional-log',
    component: ExceptionalLogPage
  },
  {
    path: '/production-overrun',
    component: ProductionOverrunReportPage
  },
  {
    path: '/inventory-comparison-report',
    component: InventoryComparisonReportPage
  },
  {
    path: '/slow-moving-stock-report',
    component: SlowMovingStockReportPage
  }
]

export default App
